import React from "react";
import {Navigate} from "react-router-dom";
import {useAuthState} from "../context/AuthContext";
import {RouteInfo} from "./RouteHelper";
import {SuperAdmin} from "../accessLevel/SuperAdmin";
import ErrorPage, {ErrorType} from "../component/ErrorPage/ErrorPage";
import {readToken} from "../service/authService/AuthService";

export default function PrivateRoute() {

    const state = useAuthState()
    const token = readToken()

    return (
        <>
            {
                token === null
                && !state.loading
                    ?
                    <Navigate to={RouteInfo.Login.globalUrl}/>
                    :
                    token !== null && !state.loading && state.role.length > 0 ?
                        <SuperAdmin/>
                        :
                        state.loading ?
                            <ErrorPage
                                errorType={ErrorType.CONNECTING}
                                title="در حال اتصال به سرور"
                                subTitle="لطفا کمی صبر نمایید..."
                                fullPage={true}/>
                            :
                            <ErrorPage
                                errorType={ErrorType.NOT_ACCESS}
                                title="عدم دسترسی"
                                subTitle="دسترسی شما به این صفحه محدود شده است، لطفا با مدیر سیستم خود تماس حاصل فرمایید!"
                                fullPage={true}/>
            }
        </>
    )

}